export default "__VITE_ASSET__DEMsnf_H__"